import React from 'react';
import { Provider } from 'react-redux';
import Modal from 'react-modal';
import { hot } from 'react-hot-loader/root';

import store from '~redux/store';
import ThemeProvider from '~app/components/@core/theme/ThemeProvider';

import Routes from './components/Routes';
import CoreSettingsWrapper from './components/CoreSettingsWrapper';

Modal.setAppElement('#root');

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <CoreSettingsWrapper>
          <Routes />
        </CoreSettingsWrapper>
      </ThemeProvider>
    </Provider>
  );
}

export default hot(App);
